import VideoPlayer from '../../../components/video-player/VideoPlayer'
import styles from './Video.module.css'

export default function Video() {
    const logo = "./assets/images/mono.png"

    const poster = "./assets/images/poster.png"

    const source = "./assets/video/mono-racing.mp4"
    const type = "video/mp4"

    const sources = [{
        src: source,
        type
    }]

    return (
        <div className={ styles.container }>
            <VideoPlayer logo={ logo } poster={ poster } sources={ sources } />
        </div>
    )
}